import { render, staticRenderFns } from "./OptionCreate.vue?vue&type=template&id=a2809666&scoped=true&"
import script from "./OptionCreate.vue?vue&type=script&lang=js&"
export * from "./OptionCreate.vue?vue&type=script&lang=js&"
import style0 from "./OptionCreate.vue?vue&type=style&index=0&id=a2809666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2809666",
  null
  
)

export default component.exports